module.exports = __webpack_public_path__ + "static/media/logo_icon.12b8f6a8.png";